import { Component, OnInit } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

const Material = [
  MatInputModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
  MatButtonModule,
];
@Component({
  selector: 'eq-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ...Material],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss',
})
export class PasswordComponent extends EqBaseComponent implements OnInit {
  hide: boolean = true;
}
